
(function () {
  'use strict';

  var TEXTE = null;
  function tx(k, rueckfall, werte) {
    if (!TEXTE) {
      try {
        var el = document.querySelector('script[data-setup-texte]');
        if (el) TEXTE = JSON.parse(el.textContent) || {};
      } catch (e) { TEXTE = {}; }
    }
    var s = (TEXTE && TEXTE[k]) || rueckfall || '';
    if (werte) {
      s = s.replace(/\{(\w+)\}/g, function (m, n) { return werte[n] != null ? String(werte[n]) : m; });
    }
    return s;
  }

  function wurzel() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function vermerken(zeilen){
    zeilen=(zeilen||[]).filter(function(z){ return z && z.key && z.handle && z.variant_id; });
    if(!zeilen.length) return Promise.resolve(false);
    return Promise.all(zeilen.map(function(z){
      return fetch(wurzel()+'products/'+encodeURIComponent(z.handle)+'?view=finder-meta&variant='+z.variant_id)
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(m){ return { z:z, v:String((m && m.vermerk) || '') }; })
        .catch(function(e){ warn('Produktdaten nicht lesbar', z.handle, e); return { z:z, v:'' }; });
    })).then(function(liste){
      var offen=liste.filter(function(x){
        var i=x.v.indexOf('|');
        if(i<1) return false;
        x.name=x.v.slice(0,i); x.wert=x.v.slice(i+1);
        return (x.z.properties||{})[x.name]!==x.wert;
      });
      if(!offen.length) return false;
      return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); }).then(function(cart){
        var kette=Promise.resolve();
        offen.forEach(function(x){
          kette=kette.then(function(){
            var zeile=(cart.items||[]).filter(function(c){ return c.key===x.z.key; })[0]
              || (cart.items||[]).filter(function(c){
                   return c.variant_id===x.z.variant_id && (c.properties||{})[x.name]!==x.wert;
                 })[0];
            if(!zeile){ warn('Zeile nicht im Korb', x.z.handle); return; }
            var props={};
            Object.keys(zeile.properties||{}).forEach(function(k){ props[k]=zeile.properties[k]; });
            props[x.name]=x.wert;
            return fetch('/cart/change.js',{ method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
              body:JSON.stringify({ id:zeile.key, quantity:zeile.quantity, properties:props }) })
              .then(function(r){ if(!r.ok) warn('Shopify lehnt ab', x.z.handle, r.status); })
              .catch(function(e){ warn('Netzwerkfehler', x.z.handle, e); });
          });
        });
        return kette.then(function(){ return true; });
      });
    }).catch(function(e){ warn('Abbruch', e); return true; });
  }

  function warn(){
    try { console.warn.apply(console, ['[Versand-Vermerk]'].concat([].slice.call(arguments))); } catch(e){}
  }

  function legen(list, done){
    var items=(list||[]).filter(Boolean).map(function(x){
      if(typeof x!=='object') return {id:x, quantity:1};
      var it={id:x.id, quantity:x.quantity||1};
      if(x.properties) it.properties=x.properties;
      if(x.selling_plan) it.selling_plan=x.selling_plan;
      return it;
    }).filter(function(x){ return x.id; });
    if(!items.length){ if(done) done(false,tx('legen_keine_variante','Keine Variante')); return; }
    var ids=[];
    document.querySelectorAll('cart-items-component').forEach(function(c){ if(c.dataset && c.dataset.sectionId && ids.indexOf(c.dataset.sectionId)<0) ids.push(c.dataset.sectionId); });
    var anfrage={items:items};
    if(ids.length) anfrage.sections=ids.join(',');
    fetch('/cart/add.js',{ method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify(anfrage) })
      .then(function(r){ return r.json().then(function(dd){ return {ok:r.ok, data:dd}; }); })
      .then(function(res){
        if(!res.ok || (res.data&&res.data.status)){ if(done) done(false,(res.data&&(res.data.description||res.data.message))||tx('legen_nicht_verfuegbar','Nicht verfügbar')); return; }
        var abschnitte=(res.data && res.data.sections) || null;
        vermerken(res.data && res.data.items).then(function(geaendert){
          if(!geaendert || !ids.length) return null;
          return fetch(wurzel()+'?sections='+encodeURIComponent(ids.join(','))).then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; });
        }).then(function(neu){
          if(neu) abschnitte=neu;
          return fetch('/cart.js');
        }).then(function(r){ return r.json(); }).then(function(cart){
          try{
            var ev=new CustomEvent('shopify:cart:lines-update',{bubbles:true});
            ev.action='add';
            ev.promise=Promise.resolve({
              cart:{ totalQuantity: cart.item_count },
              detail:{ source:'finder-clean', didError:false, items:cart.items, itemCount:cart.item_count, sections:abschnitte || undefined }
            });
            document.dispatchEvent(ev);
          }catch(e){}
          if(done) done(true);
        }).catch(function(){
          try{
            var ev2=new CustomEvent('shopify:cart:lines-update',{bubbles:true});
            ev2.action='add';
            ev2.promise=Promise.resolve({ detail:{ source:'finder-clean', didError:false } });
            document.dispatchEvent(ev2);
          }catch(e){}
          if(done) done(true);
        });
      })
      .catch(function(){ if(done) done(false,tx('legen_netzwerkfehler','Netzwerkfehler')); });
  }

  window.WarenkorbLegen = legen;
})();
